import { render, staticRenderFns } from "./CarScrappage.vue?vue&type=template&id=22ac7fe6&"
import script from "./CarScrappage.vue?vue&type=script&lang=js&"
export * from "./CarScrappage.vue?vue&type=script&lang=js&"
import style0 from "./CarScrappage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports